import script from "./Attributes.vue?vue&type=script&lang=ts&setup=true"
export * from "./Attributes.vue?vue&type=script&lang=ts&setup=true"

import "./Attributes.vue?vue&type=style&index=0&id=29b4a582&lang=scss&scoped=true"

import exportComponent from "/home/issa/hcpet/hcpet-kasse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29b4a582"]])

export default __exports__